<template>
  <div class="header_wrap_v2 community" :style="{zIndex: folded ? 7 : 13}">
    <!--head_sub-->
    <section class="header_inner">
      <h1 class="logo">
        <a class="space-logo"></a>
        <a href="/community" class="community-logo"></a>
      </h1>
      <div class="mobile_btn">
        <button type="button" class="btn_menu" @click="folded = !folded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
          >
            <path
              d="M15 22H29"
              stroke="black"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M15 29H29"
              stroke="black"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M15 15H29"
              stroke="black"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <ul class="gnb_list_box">
        <li class="nav_item">
          <a href="/community/maps" class="nav">맵스</a>
        </li>
        <li class="nav_item">
          <a href="/community/space" class="nav">스페이스</a>
        </li>
        <li class="nav_item">
          <a href="/spmall/main" class="nav">맴버십몰</a>
        </li>
        <li class="nav_item mypage right-items">
          <a href="/community/mypage/main" class="nav">마이페이지</a>
        </li>
        <li class="nav_item spark">
          <a href="https://sparkplus.kr/" target="_blank" class="nav">스파크플러스 홈</a>
        </li>
        <li
          v-if="profile?.memberShipInfo?.adminYn == 'Y'"
          class="nav_item manager"
        >
          <a :href="OFFICE_ADNIN" traget="_blanke" class="nav">매니저 어드민</a>
        </li>
      </ul>
    </section>
    <transition name="fade">
      <div
      v-if="!folded"
      class="gnb_list_layer"
      :style="{ display: folded ? 'none' : 'flex' }">
        <div class="layer_head">
          <button type="button" class="icon_close" @click="folded = !folded">
            <span class="ir_pm">모바일 메뉴 닫기</span>
          </button>
        </div>
        <div class="layer_content">
          <div class="profile">
            <div
            class="avata"
            :style="{... profile.profilePhotoAwsS3Url ? {backgroundImage:`url(${profile.profilePhotoAwsS3Url})`} : {}}">
            </div>
            <div class="info">
              <a href="/community/mypage/main" class="nav">
                <span>{{ profile.userName }}</span>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none">
                  <path
                  d="M8 13L12 9L8 5"
                  stroke="black"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
                </svg>
              </a>
              <p class="txt">
                <span>{{ profile.userPhoneNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3,4})([0-9]{3,4})([0-9]{4})/g, "$1-$2-$3") }}</span>
              </p>
            </div>
            <div class="chips">
              <span
              v-if="profile.userGradeType == 'regular-grade'"
              class="chip02">
                정회원
              </span>
              <span v-else class="chip01">
                준회원
              </span>
            </div>
          </div>

          <template v-if="tab">
            <div class="membership_link">
              <a :class="{disabled: profile.userGradeType != 'regular-grade'}" :href="profile.userGradeType == 'regular-grade' ? '/community/mypage/reserve/meeting_room_list' : '#'" class="icon1">예약내역</a>
              <a :class="{disabled: profile.userGradeType != 'regular-grade'}" :href="profile.userGradeType == 'regular-grade' ? '/community/mypage/reserve/used_meeting_list' : '#'" class="icon2">이용내역</a>
              <a :class="{disabled: profile.userGradeType != 'regular-grade'}" :href="profile.userGradeType == 'regular-grade' ? '/community/notice/main/list' : '#'" class="icon3">공지사항</a>
              <a :class="{disabled: profile.userGradeType != 'regular-grade'}" :href="profile.userGradeType == 'regular-grade' ? '/community/mypage/main/commute' : '#'" class="icon4">출퇴근내역</a>
            </div>
          </template>
          <hr class="line" v-if="!isLogin"/>
          <div v-if="tab" class="big_link">
            <a href="/community" class="nav">커뮤니티 홈</a>
            <a href="/community/maps" class="nav">맵스</a>
            <a href="/community/space" class="nav">스페이스</a>
            <a href="/spmall/main" class="nav">멤버십몰</a>
          </div>
          <div v-else class="big_link">
            <a href="/community" class="nav">커뮤니티 홈</a>
            <a href="/community/maps" class="nav">맵스</a>
            <a href="/community/space" class="nav">스페이스</a>
            <a href="/spmall/main" class="nav">멤버십몰</a>
          </div>

          <hr class="line" />
          <div class="small_link">
            <a href="https://sparkplus.kr/" target="_blank" class="nav">스파크플러스 홈</a>
            <a
            v-if="profile?.memberShipInfo?.adminYn == 'Y'"
            :href="OFFICE_ADNIN"
            target="_blank"
            class="nav manager"
            >매니저 어드민</a>
            <template v-if="tab">
            <a href="/mypage/main/setting" target="_blank" class="nav">환경설정</a>
            <a v-if="profile.userGradeType == 'regular-grade'"  href="/community/notice/main/manual_list" target="_blank" class="nav">메뉴얼</a>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CommunityHeader',
  data () {
    return {
      tab: true,
      folded: true,
      isTeamManager: false,
      isRegularMember: false,
    }
  },
  mounted () {},
  methods: {},
  components: {},
  computed: {
    ...mapGetters('user', ['profile']),
  },
  watch: {
    folded (v) {
      if (v) {
        this.tab = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.space-logo {
  height: 54px;
  width: 92px;
  background: url("data:image/svg+xml;base64,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")
    center center no-repeat;
}
.community-logo {
  display: none;
  height: 54px;
  width: 141px;
  background: url("https://static.sparkplus.co/hompage/common/logo/logo_community_white.svg")
    center center no-repeat;
}
.ir_pm {
  display: block;
  overflow: hidden;
  font-size: 0;
  line-height: 0;
  text-indent: -9999px;
}

.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* [통합]헤더 */
/* header_wrap */

.header_wrap_v2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 7;
  background-color: #fff;

  .header_inner {
    height: 50px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    display: flex;
    align-items: center;
  }

  .mobile_btn {
    margin-right: -10px;
    display: flex;
    flex-direction: row;

    button {
      width: 44px;
      height: 44px;
    }
  }

  .gnb_list_box {
    display: none;
    flex-direction: row;
    align-items: center;
    height: 64px;
    width: 100%;

    li {
      margin: 0 24px;
      position: relative;

      &.right-items {
        margin-left: auto;
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      .nav {
        font-weight: 500;
        font-size: 16px;
        color: #000;
        line-height: 1;
      }

      &.mypage::after {
        position: absolute;
        top: 50%;
        right: -24px;
        content: "";
        display: inline-block;
        margin-top: -8px;
        width: 1px;
        height: 16px;
        background-color: #e4e8eb;
        vertical-align: -1px;
      }

      &.login .nav,
      &.mypage .nav {
        color: #737373;
      }

      &.spark {
        margin-right: 8px;

        .nav {
          padding: 0 16px;
          background: #525a61;
          display: flex;
          align-items: center;
          height: 36px;
          box-sizing: border-box;
          font-weight: 500;
          font-size: 14px;
          color: #424242;
          border-radius: 20px;
        }
      }

      &.community {
        margin-right: 8px;

        .nav {
          padding: 0 16px;
          display: flex;
          align-items: center;
          height: 36px;
          box-sizing: border-box;
          font-weight: 500;
          font-size: 14px;
          color: #424242;
          border: 1px solid #e6e8eb;
          border-radius: 20px;
        }
      }

      &.manager {
        margin: 0;

        .nav {
          padding: 0 16px;
          display: flex;
          align-items: center;
          height: 36px;
          box-sizing: border-box;
          font-weight: 500;
          font-size: 14px;
          color: #8faef1 !important;
          border: 1px solid #8faef1;
          border-radius: 20px;
        }
      }
    }
  }

  &.community {
    background-color: #fff;

    .gnb_list_box li .nav {
      color: #fff;
    }
  }

  &.head_sub {
    background-color: #f9fafa;

    h1.title_sparkplus a {
      width: 24px;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M19.99 11.152c0-.417-.15-.824-.45-1.14l-6.42-5.54c-.62-.63-1.62-.63-2.24 0l-6.42 5.53a1.63 1.63 0 0 0-.46 1.15v9.814C4 22.085 4.9 23 6 23h12c1.1 0 2-.915 2-2.034v-9.814h-.01Z' fill='%239E9E9E'/%3e%3c/svg%3e");
    }

    .title_sparkplus {
      &.sp_lounge a {
        width: 144px;
        height: 30px;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='144' height='30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M26.387 3.473C24.483 1.558 20.887 0 14.92 0 8.954 0 5.358 1.558 3.455 3.473 1.55 5.387 0 9.002 0 15c0 5.998 1.55 9.613 3.455 11.527C5.36 28.442 8.955 30 14.921 30c5.966 0 9.562-1.558 11.466-3.473C28.29 24.612 29.84 20.998 29.84 15c0-5.998-1.55-9.613-3.454-11.527ZM9.897 21.54c-3.204 0-4.986-1.353-5.534-1.852a.248.248 0 0 1-.008-.358l1.411-1.418a.246.246 0 0 1 .32-.025c.46.34 1.839 1.233 3.626 1.233 2.08 0 2.168-1.522 1.817-1.947-.277-.335-.992-.758-3.004-1.215-1.962-.445-3.646-1.683-3.646-3.865 0-1.85 1.5-3.633 4.068-3.633 2.32 0 3.848 1.038 4.379 1.465a.248.248 0 0 1 .02.368l-1.421 1.429a.245.245 0 0 1-.293.041c-.563-.311-2.477-1.275-3.638-.65-.756.407-.686 1.414-.07 1.82.543.359 1.426.644 2.444.902 2.39.605 3.833 1.803 3.833 3.832 0 2.14-1.434 3.875-4.302 3.875l-.002-.002Zm11.69-4.065h-2.464v3.465c0 .137-.109.247-.245.247h-1.97a.246.246 0 0 1-.245-.247v-3.465h-.985a.245.245 0 0 1-.245-.247v-1.98c0-.136.11-.246.245-.246h.985v-2.227c0-.137.11-.247.245-.247h1.97c.136 0 .245.11.245.247v2.227h2.462c1.02 0 1.847-.832 1.847-1.857a1.852 1.852 0 0 0-1.847-1.857h-4.677a.246.246 0 0 1-.245-.246v-1.98c0-.137.11-.247.245-.247h4.677c2.427 0 4.395 1.938 4.395 4.33 0 2.392-1.966 4.33-4.393 4.33ZM37.015 5.203H39.5c.207 0 .377.17.377.378v14.827c0 .208.167.378.376.378h8.932c.208 0 .377.17.377.378v2.212a.377.377 0 0 1-.377.378H37.017a.378.378 0 0 1-.377-.378V5.581c0-.208.168-.378.377-.378h-.002ZM49.902 14.531v-.053c0-5.222 4-9.594 9.657-9.594 5.656 0 9.604 4.32 9.604 9.54v.054c0 5.221-4 9.593-9.657 9.593s-9.604-4.32-9.604-9.542v.002Zm15.867 0v-.053c0-3.605-2.605-6.574-6.264-6.574-3.658 0-6.21 2.915-6.21 6.52v.054c0 3.605 2.605 6.573 6.264 6.573 3.659 0 6.21-2.915 6.21-6.52ZM71.74 15.883V5.58c0-.208.168-.378.377-.378h2.485c.207 0 .376.17.376.378v10.17c0 3.445 1.763 5.273 4.657 5.273 2.895 0 4.632-1.723 4.632-5.141V5.58c0-.208.168-.378.377-.378h2.485c.207 0 .376.17.376.378v10.143c0 5.539-3.105 8.322-7.92 8.322-4.814 0-7.841-2.783-7.841-8.163h-.003ZM91.273 5.203h2.44c.117 0 .226.053.298.146l9.081 11.807c.219.285.673.128.673-.232V5.581c0-.208.168-.378.377-.378h2.432c.207 0 .376.17.376.378v17.795a.377.377 0 0 1-.376.378h-2.15a.372.372 0 0 1-.297-.146L94.755 11.43c-.219-.285-.673-.128-.673.232v11.713a.377.377 0 0 1-.376.378h-2.433a.378.378 0 0 1-.376-.378V5.581c0-.208.168-.378.376-.378ZM109.818 14.531v-.053c0-5.195 3.948-9.594 9.5-9.594 3.044 0 4.977.81 6.784 2.274a.38.38 0 0 1 .051.536l-1.572 1.887a.372.372 0 0 1-.522.052c-1.326-1.059-2.687-1.729-4.872-1.729-3.395 0-5.973 2.969-5.973 6.52v.054c0 3.816 2.5 6.625 6.263 6.625 1.656 0 3.168-.507 4.286-1.289a.377.377 0 0 0 .16-.311V16.63a.377.377 0 0 0-.376-.378h-3.959a.378.378 0 0 1-.376-.379V13.77c0-.208.167-.378.376-.378h7.091c.207 0 .376.17.376.378v7.237a.377.377 0 0 1-.134.29c-1.809 1.513-4.367 2.775-7.55 2.775-5.763 0-9.553-4.135-9.553-9.542v.002ZM130.586 5.203h12.905c.207 0 .376.17.376.378V7.74a.377.377 0 0 1-.376.379h-9.669a.378.378 0 0 0-.376.378v4.067c0 .208.168.378.376.378h8.485c.208 0 .377.17.377.378v2.185a.378.378 0 0 1-.377.379h-8.485a.378.378 0 0 0-.376.378v4.198c0 .209.168.379.376.379h9.802c.207 0 .376.17.376.378v2.158a.377.377 0 0 1-.376.379h-13.038a.378.378 0 0 1-.376-.379V5.581c0-.208.167-.378.376-.378Z' fill='%23000'/%3e%3c/svg%3e");
      }

      &.sp_os a {
        width: 130px;
        height: 44px;
      }

      &.sp_smart a {
        width: 197px;
        height: 30px;
        background-image: url("data:image/png;base64,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");
      }

      &.sp_waw a {
        width: 130px;
        height: 44px;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='130' height='44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23a)' fill='%23000'%3e%3cpath d='M1.292 26.42v1.785h5.083c-.306 3.417-1.921 5.848-5.831 7.82l1.19 1.734c5.406-2.703 6.919-6.613 6.919-11.339H1.292Zm10.285-1.615v6.001H8.55v1.819h3.026v7.837h2.244V24.805h-2.244Zm13.228 7.038c-2.397-.799-3.468-2.652-3.536-4.454h3.043v-1.785h-8.415v1.785h3.077c-.051 1.938-1.173 3.91-3.69 4.726l1.14 1.785c1.819-.612 3.043-1.836 3.74-3.383.68 1.394 1.836 2.516 3.553 3.077l1.088-1.751Zm-4.556 4.403h6.018v2.278h-6.018v-2.278Zm-2.21 4.029h10.42v-5.78H18.04v5.78Zm8.177-15.47v3.621h-2.363v1.819h2.363v3.604h2.244v-9.044h-2.244Zm7.243 5.117c0-1.598 1.48-2.533 3.621-2.533 2.16 0 3.638.935 3.638 2.533 0 1.598-1.479 2.533-3.638 2.533-2.142 0-3.62-.935-3.62-2.533Zm4.743 6.902v-2.652c2.771-.323 4.726-1.921 4.726-4.25 0-2.618-2.499-4.318-5.848-4.318-3.332 0-5.83 1.7-5.83 4.318 0 2.329 1.954 3.91 4.708 4.25v2.652h-5.95v1.819h14.178v-1.819h-5.984Zm10.355-8.772h1.75v6.902c-.594.017-1.172.051-1.75.051v-6.953Zm3.91 0h1.343V26.25h-8.79v1.802h1.36v7.004h-1.767l.238 1.836c2.805-.017 6.409-.085 9.707-.646l-.136-1.615c-.646.085-1.292.153-1.955.187v-6.766Zm2.958-3.23v15.657h2.26V24.822h-2.26Zm17.546 7.344c-3.536-.595-5.474-3.026-5.474-5.321v-1.122H65.1v1.122c0 2.244-1.955 4.726-5.474 5.321l.952 1.887c2.72-.527 4.709-2.057 5.712-4.046 1.003 1.989 3.009 3.502 5.729 4.046l.952-1.887Zm-13.685 4.573v1.819h14.178v-1.819H59.286ZM87.385 3.193a4.497 4.497 0 0 0-1.104-1.591 4.953 4.953 0 0 0-1.744-1.03 6.967 6.967 0 0 0-2.33-.362H76.57a.294.294 0 0 0-.295.296v2.312a.296.296 0 0 0 .295.296h2.899v-.01h2.47c.802 0 1.434.187 1.897.562.463.375.695.922.696 1.643v.042a2.087 2.087 0 0 1-.664 1.57c-.443.42-1.066.63-1.868.63h-2.237a.293.293 0 0 1-.294-.296V4.168a.296.296 0 0 0-.296-.295H76.57a.295.295 0 0 0-.295.295v3.087a.297.297 0 0 1-.297.295h-3.064a.294.294 0 0 0-.295.302l.02 2.26a.296.296 0 0 0 .294.292h3.045a.293.293 0 0 1 .294.294v3.78a.296.296 0 0 0 .295.295h2.608a.296.296 0 0 0 .296-.295v-3.781a.295.295 0 0 1 .181-.273.294.294 0 0 1 .113-.022h2.134a7.93 7.93 0 0 0 2.292-.322 5.44 5.44 0 0 0 1.867-.967c.534-.432.964-.98 1.256-1.602.305-.639.458-1.381.457-2.227v-.041a5.306 5.306 0 0 0-.384-2.05M6.044 14.979a9.584 9.584 0 0 1-3.257-.573 8.552 8.552 0 0 1-2.683-1.562.302.302 0 0 1-.035-.42l1.522-1.828a.29.29 0 0 1 .401-.04 9.252 9.252 0 0 0 1.823 1.117c.72.323 1.503.486 2.293.478.664 0 1.179-.121 1.545-.364a1.144 1.144 0 0 0 .55-1.005v-.043a1.264 1.264 0 0 0-.114-.55 1.157 1.157 0 0 0-.438-.448 4.534 4.534 0 0 0-.891-.421 15.55 15.55 0 0 0-1.488-.437 17.75 17.75 0 0 1-1.998-.603 5.59 5.59 0 0 1-1.519-.82 3.31 3.31 0 0 1-.97-1.217C.557 5.756.44 5.152.44 4.433v-.042c-.01-.62.118-1.235.372-1.8a4.09 4.09 0 0 1 1.043-1.384A4.658 4.658 0 0 1 3.46.312 6.386 6.386 0 0 1 5.51 0c1-.01 1.993.151 2.938.478a8.49 8.49 0 0 1 2.223 1.198.302.302 0 0 1 .066.411L9.4 4.031a.294.294 0 0 1-.4.074 10.137 10.137 0 0 0-1.67-.89 4.867 4.867 0 0 0-1.866-.386c-.624 0-1.09.122-1.405.364a1.105 1.105 0 0 0-.466.905v.041a1.31 1.31 0 0 0 .135.615c.116.199.286.36.49.467.306.169.631.302.968.396.409.125.926.27 1.55.438.67.172 1.326.39 1.965.654.528.214 1.02.509 1.458.874.385.326.69.735.893 1.197.214.52.316 1.08.301 1.643v.043a4.501 4.501 0 0 1-.392 1.924 3.94 3.94 0 0 1-1.093 1.412 4.892 4.892 0 0 1-1.673.875c-.7.208-1.426.31-2.156.302M14.138.504a.296.296 0 0 1 .295-.294h5.64a6.958 6.958 0 0 1 2.334.362c.646.22 1.24.57 1.745 1.03.478.444.854.987 1.103 1.591.262.651.392 1.348.383 2.05v.04a5.112 5.112 0 0 1-.457 2.228 4.523 4.523 0 0 1-1.255 1.602 5.443 5.443 0 0 1-1.867.966 7.888 7.888 0 0 1-2.292.323h-2.14a.293.293 0 0 0-.294.295v3.78a.295.295 0 0 1-.293.294h-2.608a.295.295 0 0 1-.295-.295V.504Zm5.728 7.046c.802 0 1.425-.21 1.867-.633a2.08 2.08 0 0 0 .664-1.57v-.043c0-.72-.232-1.269-.694-1.644-.463-.375-1.096-.562-1.9-.561h-2.176a.294.294 0 0 0-.294.295v3.862a.292.292 0 0 0 .182.272.292.292 0 0 0 .112.022h2.239ZM31.828.375a.485.485 0 0 1 .41-.271h2.357a.484.484 0 0 1 .41.271l5.935 13.986a.294.294 0 0 1-.27.41H38.07a.474.474 0 0 1-.402-.274l-1.103-2.715a.475.475 0 0 0-.401-.273h-5.566a.473.473 0 0 0-.401.273l-1.103 2.715a.476.476 0 0 1-.402.274h-2.53a.294.294 0 0 1-.269-.41L31.828.374Zm3.31 7.894-1.493-3.65a.295.295 0 0 0-.435-.133.294.294 0 0 0-.108.132L31.61 8.27a.294.294 0 0 0 .272.402h2.984a.294.294 0 0 0 .29-.262.296.296 0 0 0-.018-.14ZM43.658.504a.295.295 0 0 1 .294-.294h6.347c1.84 0 3.25.493 4.233 1.477.83.831 1.245 1.94 1.244 3.328v.042c0 1.178-.287 2.139-.86 2.881a4.93 4.93 0 0 1-1.917 1.496.29.29 0 0 0-.177.312.29.29 0 0 0 .045.119l3.033 4.444a.297.297 0 0 1-.09.42.293.293 0 0 1-.153.042h-3.18l-3.11-4.66h-2.22a.294.294 0 0 0-.294.295v4.07a.295.295 0 0 1-.294.295h-2.607a.294.294 0 0 1-.294-.295V.504ZM50.09 7.28c.788 0 1.393-.187 1.815-.561.42-.374.632-.874.633-1.498V5.18c0-.693-.221-1.214-.664-1.56-.444-.347-1.06-.52-1.847-.52h-2.88a.294.294 0 0 0-.294.295v3.591a.295.295 0 0 0 .294.295h2.943ZM59.692.21H62.3a.293.293 0 0 1 .294.295v5.319a.295.295 0 0 0 .36.288.294.294 0 0 0 .15-.087L68.486.21h3.168a.293.293 0 0 1 .293.35.295.295 0 0 1-.08.153l-5.265 5.5a.293.293 0 0 0-.025.379l5.69 7.713a.295.295 0 0 1-.237.47h-3.253l-4.297-5.918a.294.294 0 0 0-.45-.03l-1.438 1.494v4.158a.295.295 0 0 1-.294.295h-2.608a.294.294 0 0 1-.294-.295V.503a.295.295 0 0 1 .294-.295M90.78.21h2.608a.294.294 0 0 1 .3.295v11.08a.292.292 0 0 0 .293.295h6.656c.078 0 .152.031.207.087.056.055.086.13.086.209v2.301c0 .078-.03.153-.086.208a.291.291 0 0 1-.207.087h-9.85a.294.294 0 0 1-.294-.295V.501a.295.295 0 0 1 .294-.295M109.038 15c-1.95 0-3.486-.54-4.607-1.623-1.121-1.082-1.682-2.698-1.682-4.847V.504a.29.29 0 0 1 .181-.272.287.287 0 0 1 .112-.023h2.608a.295.295 0 0 1 .294.295v7.943c0 1.194.277 2.092.831 2.694.555.602 1.324.903 2.307.905.982 0 1.751-.291 2.307-.874.556-.582.832-1.456.829-2.621V.507a.292.292 0 0 1 .294-.295h2.608a.295.295 0 0 1 .295.295v7.918c0 1.11-.149 2.074-.446 2.893-.271.77-.71 1.47-1.287 2.048a5.208 5.208 0 0 1-2.006 1.228 8.09 8.09 0 0 1-2.636.402M123.856 14.979a9.584 9.584 0 0 1-3.259-.573 8.555 8.555 0 0 1-2.683-1.562.302.302 0 0 1-.034-.42l1.519-1.828a.292.292 0 0 1 .401-.04 9.27 9.27 0 0 0 1.824 1.117 5.465 5.465 0 0 0 2.293.478c.664 0 1.179-.12 1.547-.364a1.143 1.143 0 0 0 .548-1.005v-.042a1.246 1.246 0 0 0-.113-.551 1.166 1.166 0 0 0-.438-.448 4.52 4.52 0 0 0-.894-.416 15.281 15.281 0 0 0-1.488-.436 17.765 17.765 0 0 1-1.997-.604 5.597 5.597 0 0 1-1.518-.82 3.329 3.329 0 0 1-.967-1.222c-.229-.485-.343-1.089-.343-1.81v-.042c-.01-.62.117-1.234.37-1.8.245-.53.6-1.001 1.042-1.382a4.66 4.66 0 0 1 1.6-.895A6.384 6.384 0 0 1 123.317 0a8.696 8.696 0 0 1 2.936.479c.8.285 1.552.688 2.232 1.197a.302.302 0 0 1 .065.411l-1.338 1.943a.294.294 0 0 1-.401.074 10.19 10.19 0 0 0-1.669-.89 4.871 4.871 0 0 0-1.867-.386c-.623 0-1.091.122-1.404.364a1.11 1.11 0 0 0-.467.905v.042c-.006.212.04.423.134.614.116.199.286.361.49.468.307.168.631.301.968.396.409.124.924.27 1.55.437.67.172 1.327.39 1.966.655a5.494 5.494 0 0 1 1.457.873c.385.326.691.735.895 1.197a4.09 4.09 0 0 1 .301 1.643v.043a4.516 4.516 0 0 1-.392 1.924 3.93 3.93 0 0 1-1.093 1.415 4.91 4.91 0 0 1-1.674.874 7.269 7.269 0 0 1-2.153.302'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath fill='%23fff' d='M0 0h130v44H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e");
      }
    }

    .sub_head {
      height: 80px;
      background-color: #fff;
      box-shadow: inset 0 -1px 0 0 #efefef;

      .lnb_list {
        top: 22px;

        a {
          font-size: 16px;
          color: #424242;

          &:hover,
          &.on {
            color: #31a49e;
          }
        }
      }
    }
  }
}

/* list_nav gnb메뉴 m에서 노출 */
/* community header */
/* sub head */
/* icon */
.icon_close {
  background-image: url("https://static.sparkplus.co/hompage/common/icon/icon_close.png");
}

/* .icon_nav{background-image:url("https://static.sparkplus.co/hompage/common/icon/icon_mobile_menu.png");} */

.icon_sparkplus {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='152' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23a)' fill='%232CB6AF'%3e%3cpath d='M102.541 6.983a5.252 5.252 0 0 0-1.311-1.858 5.902 5.902 0 0 0-2.072-1.201A8.411 8.411 0 0 0 96.39 3.5h-6.696a.353.353 0 0 0-.248.101.343.343 0 0 0-.103.244v2.7c0 .091.037.179.103.244a.353.353 0 0 0 .248.1h3.443V6.88h2.934c.953 0 1.704.219 2.254.656.55.438.825 1.077.827 1.918v.05c.007.342-.06.683-.195 1-.136.315-.338.6-.594.833-.526.489-1.266.733-2.218.733h-2.659a.354.354 0 0 1-.247-.101.341.341 0 0 1-.102-.244V8.121a.34.34 0 0 0-.217-.318.355.355 0 0 0-.134-.026h-3.092a.353.353 0 0 0-.248.1.343.343 0 0 0-.103.244v3.603a.341.341 0 0 1-.218.32.355.355 0 0 1-.135.025h-3.64a.354.354 0 0 0-.325.218.34.34 0 0 0-.025.134l.023 2.638c0 .09.038.177.104.241.065.064.154.1.246.1h3.617c.093 0 .182.036.247.1a.341.341 0 0 1 .103.244v4.412c0 .091.037.179.103.243.065.065.154.101.247.101h3.098a.354.354 0 0 0 .324-.212.343.343 0 0 0 .028-.132v-4.414a.337.337 0 0 1 .101-.244.35.35 0 0 1 .248-.1h2.535a9.572 9.572 0 0 0 2.723-.376 6.495 6.495 0 0 0 2.217-1.129 5.313 5.313 0 0 0 1.493-1.87c.363-.745.543-1.612.543-2.6v-.048a6.099 6.099 0 0 0-.457-2.392M7.452 20.5c-1.37-.001-2.729-.221-4.017-.65-1.21-.4-2.33-1.001-3.307-1.773a.325.325 0 0 1-.043-.477l1.876-2.075a.38.38 0 0 1 .495-.044c.693.5 1.447.926 2.247 1.267a7.225 7.225 0 0 0 2.826.543c.82 0 1.454-.138 1.906-.413.212-.119.386-.287.505-.487s.178-.426.173-.654v-.048a1.337 1.337 0 0 0-.141-.626 1.371 1.371 0 0 0-.54-.508 5.822 5.822 0 0 0-1.099-.478 20.438 20.438 0 0 0-1.834-.495 23.315 23.315 0 0 1-2.463-.684 7.098 7.098 0 0 1-1.872-.932 3.829 3.829 0 0 1-1.196-1.38C.686 10.033.543 9.348.543 8.532v-.048A4.478 4.478 0 0 1 1 6.44a4.699 4.699 0 0 1 1.286-1.57 5.897 5.897 0 0 1 1.979-1.016 8.5 8.5 0 0 1 2.529-.354 11.58 11.58 0 0 1 3.62.543c.983.324 1.907.782 2.742 1.359a.339.339 0 0 1 .142.218.321.321 0 0 1-.062.248l-1.645 2.206a.367.367 0 0 1-.23.135.387.387 0 0 1-.265-.05c-.65-.396-1.34-.734-2.058-1.011a6.45 6.45 0 0 0-2.301-.437c-.77 0-1.344.138-1.731.413-.178.116-.324.27-.424.448-.1.18-.152.377-.151.579v.046c-.007.242.05.481.166.698.143.225.353.41.604.53.378.192.778.343 1.193.45a63.85 63.85 0 0 0 1.91.496c.827.195 1.637.444 2.425.743a6.909 6.909 0 0 1 1.796.992c.475.37.852.834 1.102 1.358.263.59.39 1.226.371 1.864v.05a4.762 4.762 0 0 1-.483 2.182 4.539 4.539 0 0 1-1.348 1.603 6.227 6.227 0 0 1-2.063.993 9.702 9.702 0 0 1-2.657.343M17.001 3.844c0-.091.036-.178.098-.243a.328.328 0 0 1 .235-.1h6.376a7.633 7.633 0 0 1 2.636.423c.73.256 1.402.665 1.973 1.202.54.519.966 1.153 1.247 1.858.296.76.443 1.573.433 2.392v.048a6.137 6.137 0 0 1-.517 2.6 5.259 5.259 0 0 1-1.418 1.87 6.085 6.085 0 0 1-2.111 1.129 8.648 8.648 0 0 1-2.59.377h-2.418a.322.322 0 0 0-.235.1.344.344 0 0 0-.097.243v4.413a.35.35 0 0 1-.098.243.326.326 0 0 1-.234.101h-2.948a.328.328 0 0 1-.235-.1.351.351 0 0 1-.098-.244l.001-16.312Zm6.474 8.226c.907 0 1.61-.246 2.11-.74.243-.232.435-.517.564-.833.13-.316.193-.657.186-1v-.049c0-.841-.262-1.481-.785-1.92-.522-.438-1.238-.656-2.145-.654h-2.46a.326.326 0 0 0-.235.1.35.35 0 0 0-.097.244v4.508a.351.351 0 0 0 .097.244.33.33 0 0 0 .235.1h2.53ZM37.711 3.815a.558.558 0 0 1 .19-.222.534.534 0 0 1 .271-.093h2.656c.097.005.19.037.272.093a.558.558 0 0 1 .189.222l6.684 16.21a.35.35 0 0 1-.028.322.334.334 0 0 1-.275.153h-2.93a.523.523 0 0 1-.269-.094.546.546 0 0 1-.183-.223l-1.243-3.147a.546.546 0 0 0-.184-.222.524.524 0 0 0-.268-.095h-6.268a.522.522 0 0 0-.268.095.546.546 0 0 0-.184.222l-1.242 3.147a.546.546 0 0 1-.184.223.522.522 0 0 1-.268.094H31.33a.323.323 0 0 1-.275-.154.349.349 0 0 1-.028-.322l6.684-16.21Zm3.728 9.15-1.68-4.232a.34.34 0 0 0-.123-.154.324.324 0 0 0-.368 0 .339.339 0 0 0-.122.154l-1.68 4.231a.351.351 0 0 0 .034.317.335.335 0 0 0 .272.15h3.36a.327.327 0 0 0 .272-.15.348.348 0 0 0 .035-.317ZM51 3.843c0-.091.038-.178.105-.243a.366.366 0 0 1 .254-.1h7.744c2.244 0 3.966.575 5.165 1.725 1.013.97 1.52 2.265 1.518 3.885v.048c0 1.376-.35 2.498-1.05 3.365a5.985 5.985 0 0 1-2.338 1.746.338.338 0 0 0-.216.364c.007.05.026.097.055.14l3.7 5.188a.335.335 0 0 1-.11.49.37.37 0 0 1-.186.049h-3.88l-3.794-5.44h-2.71a.366.366 0 0 0-.253.1.337.337 0 0 0-.105.244v4.752a.337.337 0 0 1-.105.243.366.366 0 0 1-.253.101h-3.182a.367.367 0 0 1-.254-.1.337.337 0 0 1-.105-.244V3.843Zm7.848 7.912c.962 0 1.7-.218 2.214-.655.514-.436.772-1.02.774-1.749v-.048c0-.81-.27-1.418-.812-1.822-.54-.405-1.291-.607-2.253-.607h-3.513a.366.366 0 0 0-.254.1.337.337 0 0 0-.105.244v4.193c0 .091.038.179.105.244.067.064.159.1.254.1h3.59ZM70.342 3.502h3.026a.339.339 0 0 1 .315.213.345.345 0 0 1 .026.131v6.207a.346.346 0 0 0 .216.321.339.339 0 0 0 .375-.086l6.245-6.786h3.677a.339.339 0 0 1 .319.21.346.346 0 0 1-.073.377l-6.108 6.418a.343.343 0 0 0-.03.443l6.603 9a.345.345 0 0 1-.275.55h-3.774l-4.986-6.906a.342.342 0 0 0-.399-.118.339.339 0 0 0-.123.082l-1.669 1.744v4.852a.34.34 0 0 1-.34.344H70.34a.34.34 0 0 1-.341-.344V3.844a.345.345 0 0 1 .341-.344M106.33 3.505h2.998a.336.336 0 0 1 .319.21.34.34 0 0 1 .027.134V16.78a.348.348 0 0 0 .098.243.347.347 0 0 0 .239.1h7.651c.09.001.176.038.239.102a.35.35 0 0 1 .099.244v2.686a.349.349 0 0 1-.099.243.334.334 0 0 1-.239.101h-11.324a.334.334 0 0 1-.239-.1.349.349 0 0 1-.099-.244V3.844a.349.349 0 0 1 .209-.318.333.333 0 0 1 .129-.026M127.448 20.5c-2.309 0-4.128-.66-5.456-1.982-1.328-1.321-1.992-3.294-1.992-5.92V3.86a.357.357 0 0 1 .214-.332.335.335 0 0 1 .133-.028h3.088a.34.34 0 0 1 .246.105.363.363 0 0 1 .102.255v8.638c0 1.458.328 2.554.985 3.29.656.734 1.567 1.103 2.732 1.104 1.163 0 2.074-.355 2.732-1.067.658-.711.985-1.778.981-3.2V3.862a.362.362 0 0 1 .216-.332.337.337 0 0 1 .133-.027h3.089c.092 0 .181.038.246.105a.364.364 0 0 1 .103.254v8.608c0 1.355-.176 2.533-.529 3.532a6.688 6.688 0 0 1-1.524 2.502 6.13 6.13 0 0 1-2.375 1.499 9.313 9.313 0 0 1-3.122.491M145.453 20.497c-1.37 0-2.729-.22-4.018-.65-1.21-.4-2.331-1-3.307-1.772a.332.332 0 0 1-.127-.23.325.325 0 0 1 .085-.247l1.873-2.074a.382.382 0 0 1 .495-.045c.694.5 1.448.926 2.248 1.266a7.238 7.238 0 0 0 2.827.544c.818 0 1.454-.138 1.906-.413.212-.12.386-.287.504-.487.119-.2.179-.426.173-.654v-.048a1.314 1.314 0 0 0-.14-.626 1.374 1.374 0 0 0-.54-.507 5.804 5.804 0 0 0-1.102-.473 20.156 20.156 0 0 0-1.834-.495 23.294 23.294 0 0 1-2.462-.685 7.101 7.101 0 0 1-1.872-.93 3.846 3.846 0 0 1-1.192-1.387c-.282-.55-.423-1.236-.423-2.054v-.048a4.49 4.49 0 0 1 .456-2.042 4.698 4.698 0 0 1 1.285-1.57 5.89 5.89 0 0 1 1.972-1.015 8.505 8.505 0 0 1 2.529-.354 11.572 11.572 0 0 1 3.62.543c.985.323 1.913.781 2.751 1.359a.323.323 0 0 1 .08.467l-1.649 2.204a.369.369 0 0 1-.229.134.388.388 0 0 1-.266-.05 12.861 12.861 0 0 0-2.058-1.01 6.445 6.445 0 0 0-2.301-.438c-.768 0-1.345.138-1.731.413a1.29 1.29 0 0 0-.423.449c-.1.179-.152.377-.152.578v.047c-.008.241.049.48.164.697.144.226.353.41.605.53.378.192.778.343 1.193.45.505.142 1.139.307 1.911.497.826.194 1.636.442 2.424.742a6.895 6.895 0 0 1 1.796.992c.475.37.852.834 1.104 1.358.261.591.387 1.226.37 1.864v.05a4.747 4.747 0 0 1-.483 2.182 4.522 4.522 0 0 1-1.347 1.605 6.25 6.25 0 0 1-2.064.993 9.688 9.688 0 0 1-2.655.343'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath fill='%23fff' d='M0 0h152v24H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e");
}

.icon_community {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='186' height='21' fill='none'%3E%3Cg fill='%23000' clip-path='url(%23a)'%3E%3Cpath d='M10.295 21c3.872 0 6.166-1.392 8.23-3.626l-2.81-2.871c-1.577 1.45-2.982 2.378-5.277 2.378-3.44 0-5.821-2.9-5.821-6.381v-.058c0-3.48 2.438-6.323 5.821-6.323 2.008 0 3.585.87 5.134 2.291l2.81-3.277C16.518 1.276 14.252 0 10.467 0 4.302 0 0 4.728 0 10.5v.058C0 16.388 4.388 21 10.295 21ZM31.251 21c6.194 0 10.697-4.728 10.697-10.5v-.058C41.948 4.67 37.503 0 31.308 0c-6.194 0-10.696 4.728-10.696 10.5v.058C20.612 16.33 25.057 21 31.252 21Zm.057-4.119c-3.555 0-6.08-2.9-6.08-6.381v-.058c0-3.48 2.467-6.323 6.023-6.323 3.556 0 6.08 2.9 6.08 6.381v.058c0 3.48-2.467 6.323-6.023 6.323ZM45.865 20.652h4.33V7.483l5.593 8.586h.114l5.65-8.673v13.256h4.387V.348h-4.76l-5.277 8.586L50.626.348h-4.76v20.304ZM70.762 20.652h4.33V7.483l5.592 8.586h.115l5.65-8.673v13.256h4.387V.348h-4.76l-5.277 8.586L75.522.348h-4.76v20.304ZM104.032 20.971c5.392 0 8.804-3.017 8.804-9.166V.348h-4.416V11.98c0 3.22-1.635 4.873-4.33 4.873-2.696 0-4.33-1.711-4.33-5.018V.348h-4.417V11.95c0 5.975 3.298 9.021 8.689 9.021ZM117.335 20.652h4.359V7.744l9.721 12.908h3.757V.348h-4.359V12.85L121.407.35h-4.072v20.303ZM140.192 20.652h4.416V.348h-4.416v20.304ZM154.299 20.652h4.416V4.467h6.109V.348h-16.633v4.119h6.108v16.185ZM173.87 20.652h4.416v-8.093L186 .35h-5.019l-4.875 8.15-4.789-8.15h-5.162l7.715 12.297v8.006Z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h186v21H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
}

.icon_arrow_right::after {
  content: "";
  display: inline-block;
  width: 8px;
  height: 14px;
  background-size: cover;
  background-image: url("https://static.sparkplus.co/hompage/common/icon/icon_arrow_right.png");
  vertical-align: middle;
  margin-left: 15px;
  position: relative;
  top: -2px;
}

@media screen and (min-width: 769px) {
  /* 브라우져 가로길이 769 보다 큰경우 style */

  .header_wrap_v2 {
    &.community {
      background-color: #40474d;
    }
    .header_inner {
      height: 64px;
      padding-left: 24px;
      padding-right: 24px;
    }
    .logo {
      margin-right: 48px;
      .space-logo {display: none;}
      .community-logo {display: block;}
    }

    .mobile_btn {
      display: none;
    }

    .gnb_list_box {
      display: flex;
    }
  }

}

@media screen and (max-width:768px) {
  /* 브라우져 가로길이 640 보다 작은경우 style */
}

.gnb_list_layer {
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 13;
  background: #fff;
  text-align: left;

  .line {
    border: 0;
    border-top: 1px solid #e6e8eb;
    margin: 0 -20px;
  }

  .layer_head {
    padding: 0 20px;
    min-height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .icon_close {
      margin-right: -15px;
      width: 44px;
      height: 44px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .layer_content {
    padding: 0 20px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .login {
    padding: 8px 0 32px 0;
    display: flex;
    flex-direction: column;

    .nav {
      margin-bottom: 8px;
    }

    .txt {
      font-weight: 400;
      font-size: 14px;
    }
  }

  .big_link {
    padding: 16px 0;
    display: flex;
    flex-direction: column;

    .nav {
      padding: 19px 0;
    }
  }

  .small_link {
    padding: 16px 0;
    display: flex;
    flex-direction: column;

    .nav {
      padding: 12px 0;
      font-size: 16px;
      font-weight: 500;
      color: #737373;
    }

    .manager {
      color: #1e5de3;
    }
  }

  .profile {
    padding: 8px 0;
    display: flex;
    flex-direction: row;
    align-items: center;

    .avata {
      margin-right: 16px;
      min-width: 56px;
      height: 56px;
      border-radius: 28px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url("https://static.sparkplus.co/hompage/common/icon/icon_avata_default.png");
      // background-size: cover;
    }

    .info {
      display: flex;
      flex-direction: column;

      .nav {
        align-items: center;
        display: flex;
      }

      .txt {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #737373;
        margin-top: 4px;

        .manager {
          color: #36b6b0;

          .icon_circle {
            width: 3px;
            height: 3px;
            background: #36b6b0;
            display: inline-block;
            border-radius: 10px;
            margin: 3px 10px;
          }
        }
      }
    }

    .chips {
      margin-left: auto;
      display: flex;
      flex-direction: column;

      span {
        padding: 0 8px;
        height: 28px;
        line-height: 26px;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
      }

      .chip01 {
        background: #f9fafa;
        border: 1px solid #e6e8eb;
        box-sizing: border-box;
        color: #525a61;
      }

      .chip02 {
        background: #fef7f6;
        border: 1px solid #f9d0c6;
        box-sizing: border-box;
        color: #f56d4c;
      }
    }
  }

  .nav {
    font-weight: 600;
    font-size: 18px;
    line-height: 1;
    color: #000;
  }

  .membership_link {
    padding: 24px 0;
    display: flex;
    flex-direction: row;
    gap: 16px;

    a,
    span {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      width: 25%;
      height: 55px;

      img {
        width: 30px;
      }
    }
  }
}

.membership_link a {
    display: block;
    padding-top: 35px;
    font-size: 13px;
    font-weight: 500;
    color: #000;
    text-align: center;
}
.membership_link a.icon1 {
    background: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='5' y='6.25' width='20' height='18.75' rx='2.5' stroke='black' stroke-width='1.75'/%3E%3Cpath d='M10.875 3.75C10.875 3.26675 10.4832 2.875 10 2.875C9.51675 2.875 9.125 3.26675 9.125 3.75H10.875ZM9.125 3.75V6.25H10.875V3.75H9.125Z' fill='black'/%3E%3Cpath d='M20.875 3.75C20.875 3.26675 20.4832 2.875 20 2.875C19.5168 2.875 19.125 3.26675 19.125 3.75H20.875ZM19.125 3.75V6.25H20.875V3.75H19.125Z' fill='black'/%3E%3Cpath d='M10.625 15.625L13.5732 18.5732C13.6709 18.6709 13.8291 18.6709 13.9268 18.5732L19.375 13.125' stroke='black' stroke-width='1.75' stroke-linecap='round'/%3E%3C/svg%3E%0A") no-repeat center top;
}
.membership_link a.icon2 {
    background: url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='1' y='1' width='20' height='20' rx='2.5' stroke='black' stroke-width='1.75'/%3E%3Cpath d='M6 11V16' stroke='black' stroke-width='1.75' stroke-linecap='round'/%3E%3Cpath d='M11 6V16' stroke='black' stroke-width='1.75' stroke-linecap='round'/%3E%3Cpath d='M16 8.5V16' stroke='black' stroke-width='1.75' stroke-linecap='round'/%3E%3C/svg%3E%0A") no-repeat center 4px;
}

.membership_link a.icon3 {
    background: url("data:image/svg+xml,%3Csvg width='24' height='26' viewBox='0 0 24 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.75 20.5C15.75 22.5711 14.0711 24.25 12 24.25C9.92893 24.25 8.25 22.5711 8.25 20.5' stroke='black' stroke-width='1.75' stroke-linecap='round'/%3E%3Cpath d='M4.34954 15.0505L1.63435 18.2183C1.28685 18.6237 1.57492 19.25 2.10889 19.25H21.8911C22.4251 19.25 22.7132 18.6237 22.3656 18.2183L19.6505 15.0505C19.5534 14.9373 19.5 14.793 19.5 14.6438V9.25C19.5 5.10786 16.1421 1.75 12 1.75C7.85786 1.75 4.5 5.10786 4.5 9.25V14.6438C4.5 14.793 4.44663 14.9373 4.34954 15.0505Z' stroke='black' stroke-width='1.75' stroke-linecap='round'/%3E%3C/svg%3E%0A")no-repeat center top;
}

.membership_link a.icon4 {
    background: url("data:image/svg+xml,%3Csvg width='22' height='24' viewBox='0 0 22 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='1' y='4.25' width='20' height='18.75' rx='2.5' stroke='black' stroke-width='1.75'/%3E%3Cpath d='M6.875 1.75C6.875 1.26675 6.48325 0.875 6 0.875C5.51675 0.875 5.125 1.26675 5.125 1.75H6.875ZM5.125 1.75V4.25H6.875V1.75H5.125Z' fill='black'/%3E%3Cpath d='M16.875 1.75C16.875 1.26675 16.4832 0.875 16 0.875C15.5168 0.875 15.125 1.26675 15.125 1.75H16.875ZM15.125 1.75V4.25H16.875V1.75H15.125Z' fill='black'/%3E%3Cellipse cx='6.00024' cy='9.37425' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='11.0002' cy='9.37425' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='16.0002' cy='9.37425' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='16.0002' cy='13.6243' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='16.0002' cy='17.8738' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='11.0002' cy='13.6243' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='11.0002' cy='17.8738' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='6.00024' cy='13.6243' rx='1' ry='0.999739' fill='black'/%3E%3Cellipse cx='6.00024' cy='17.8738' rx='1' ry='0.999739' fill='black'/%3E%3C/svg%3E%0A")no-repeat center top;
}
    /* height:55px; 준회원 배열정렬 관련 */
.gnb_list_layer .membership_link a.disabled {
    opacity: .4;
}

</style>
